import React from 'react';
import { BiSearch } from 'react-icons/bi';

import { Container, Input } from './styles';

function InputSearch({
  setSearchValue,
  searchValue,
}) {

  return (
    <Container>
      <BiSearch size={22} color="#0000008a" />
      <Input
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        placeholder="Pesquise pelo nome do documento"
      />
    </Container>
  )
}

export default InputSearch;
